import { all, fork } from 'redux-saga/effects';

//public
import LayoutSaga from './layout/saga';
import RegisterSaga from './register/saga';

export default function* rootSaga() {
  yield all([fork(LayoutSaga)]);
  yield all([fork(RegisterSaga)]);
}
